module.exports = __webpack_public_path__ + "img/switzerland_.0ec3b8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mbbs_fair/switzerland_.jpg
// module id = 837
// module chunks = 1